import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { FormDialog } from "@/components/FormDialog";
import { api, errMsg } from "@/lib/api";
import { useList } from "@/lib/technicians";

const ROOT = "__root__";
const depth = (z) => z.path.split(" / ").length - 1;

export const ZonesTab = () => {
  const [zones, reload] = useList("/zones");
  const [dlg, setDlg] = useState(null);
  const fields = [
    { name: "name", label: "Nombre", required: true, placeholder: "Ej. Estado de México" },
    { name: "parent_id", label: "Dentro de", type: "select", options: [{ value: ROOT, label: "— Nivel principal —" },
      ...zones.filter((z) => !dlg?.zone || !z.ancestors.includes(dlg.zone.id)).map((z) => ({ value: z.id, label: z.path }))] },
    { name: "order", label: "Orden", type: "number", default: 100 },
  ];
  const save = async (f) => {
    const body = { ...f, parent_id: f.parent_id === ROOT ? null : f.parent_id, order: Number(f.order) || 100 };
    if (dlg.zone) await api.patch(`/zones/${dlg.zone.id}`, body); else await api.post("/zones", body);
    toast.success("Zona guardada");
    reload();
  };
  const toggle = async (z, active) => {
    try { await api.patch(`/zones/${z.id}`, { active }); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-3xl space-y-3" data-testid="zones-tab">
      <p className="text-sm text-muted-foreground">Zonas de cobertura de técnicos y zona de servicio de cada OS. Sin límite de niveles (Estado → Municipio → Colonia…).</p>
      <Button onClick={() => setDlg({})} data-testid="zone-add-button"><Plus className="mr-2 h-4 w-4" />Nueva zona</Button>
      <div className="rounded-lg border border-border">
        {zones.map((z) => (
          <div key={z.id} className="flex items-center gap-3 border-b border-border/60 px-3 py-2 last:border-0" style={{ paddingLeft: 12 + depth(z) * 24 }} data-testid={`zone-row-${z.id}`}>
            <span className={`text-sm ${z.active ? "" : "text-muted-foreground line-through"}`}>{z.name}</span>
            <div className="ml-auto flex items-center gap-2">
              <Button size="sm" variant="ghost" onClick={() => setDlg({ parent: z.id })} data-testid={`zone-add-child-${z.id}`}><Plus className="mr-1 h-3.5 w-3.5" />Subzona</Button>
              <Button size="icon" variant="ghost" onClick={() => setDlg({ zone: z })} data-testid={`zone-edit-${z.id}`}><Pencil className="h-4 w-4" /></Button>
              <Switch checked={z.active} onCheckedChange={(v) => toggle(z, v)} data-testid={`zone-active-${z.id}`} />
            </div>
          </div>
        ))}
        {!zones.length && <p className="p-4 text-sm text-muted-foreground">Sin zonas. Crea, por ejemplo, "Estado de México" y dentro "Tecámac".</p>}
      </div>
      <FormDialog open={!!dlg} onOpenChange={(o) => !o && setDlg(null)} title={dlg?.zone ? "Editar zona" : "Nueva zona"} fields={fields}
        initial={dlg?.zone ? { name: dlg.zone.name, parent_id: dlg.zone.parent_id || ROOT, order: dlg.zone.order } : { parent_id: dlg?.parent || ROOT }} onSubmit={save} testid="zone-form" />
    </div>
  );
};
